exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml {\n  height: 100%;\n}\nbody {\n  height: 100%;\n  margin: 0;\n  font-family: proxima-nova, sans-serif;\n  font-style: normal;\n  font-size: 1rem;\n}\n#app {\n  height: 100%;\n}\n#no-layout-container {\n  height: 100%;\n}\n.logo-container {\n  background-image: url('/assets/logoEffortlessExperienceDark.png');\n  width: 353px;\n  height: 77px;\n  margin-top: 40px;\n}\n\n", ""]);

// exports
